module.exports = __webpack_public_path__ + "static/media/highTeachLogo.89304922.png";